import React, { useEffect, useState } from "react";
import {
  BusinessAddressIcon,
  BusinessInformationIcon,
  BusinessInformationRedIcon,
  CreateAccountIcon,
  PasswordSettingIcon,
  PasswordSettingRedIcon,
  PersonalDetailIcon,
  PersonalInformationIcon,
  PersonalInformationRedIcon,
  ProjExelLogo,
} from "../../assets/images";
import CreateAccountWithOtp from "./CreateAccountWithOtp";
import LeftSideSignUpInfo from "./LeftSideSignUpInfo";
import VerifySignUpOtp from "./VerifySignUpOtp";
import PersonalInformationForm from "./PersonalInformationForm";
import BusinessDetailForm from "./BusinessDetailForm";
import PasswordDetails from "./PasswordDetails";
import "./SignUpCard.scss";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import {
  CheckUniquiEmailAndMobilePayloadType,
  GetCityListSignUpDataPayloadType,
  GetCountryListSignUpDataPayloadType,
  GetSignUpOtpPayloadType,
  GetStateListSignUpDataPayloadType,
  SignUpOtpVerifyPayloadType,
  SignUpUserPayloadType,
} from "../../commonTypes/authTypes";
import {
  checkUniqueEmailSignUpAction,
  checkUniqueMobileNoSignUpAction,
  createOrderAction,
  getAllCitySignUpAction,
  getAllCountrySignUpAction,
  getAllStateSignUpAction,
  getOtpSignUpAction,
  resetAuthError,
  resetAuthMessage,
  resetAuthSuccess,
  resetCityList,
  resetIsSignupEmail,
  resetIsSignUpMobileNo,
  resetSignUpEmailError,
  resetSignUpEmailFetching,
  resetSignUpEmailMessage,
  resetSignUpMobileError,
  resetSignUpMobileFetching,
  resetSingUpMobileMessage,
  resetStateList,
  resetStateListTotalCount,
  signUpClientAction,
  signUpOtpVerifyAction,
  verifyPaymentAction,
} from "../../redux/auth";
import useDebounce from "../../customHooks/useDebounce";
import { isEmailValid } from "../../utils/commonFunctions";
import {
  CityListTypes,
  CountryListTypes,
  StateListTypes,
} from "../../redux/auth/authTypes";
import { ErrorSuccessModal } from "../commons";
import toast, { Toaster } from "react-hot-toast";
type UniqueMobileNoType = {
  operation: string | null;
  mobile: number | null | undefined;
};
export type DropDownType = {
  value: null | string;
  label: string;
};
type UniqueEmailType = {
  operation: string | null;
  email: string | null | undefined;
};
export type UserProfileDetailErrorType = {
  emailError: string;
  newPasswordError: string;
  newPasswordAgainError: string;
  countryError: string;
  stateError: string;
  cityError: string;
};
export type PasswordValidationType = {
  atLeast: boolean;
  upperCase: boolean;
  special: boolean;
  lowerCase: boolean;
  number: boolean;
};
export type UserDetailsType = {
  mobileNumber: string;
  otp: string;
  personalInfo: {};
  businessInfo: {};
  passworDetails: {
    email: string;
    password: string;
    newPassword: string;
  };
};
type AppProps = {
  token: string | null;
  emailMessage: null | string;
  emailFetching: boolean;
  isEmail: number | null;
  mobileMessage: null | string;
  mobileFetching: boolean;
  isMobileNo: number | null;
  countryList: CountryListTypes[] | [];
  countryListTotalCount: number;
  countryFetching: boolean;
  stateList: StateListTypes[] | [];
  stateListTotalCount: number;
  stateFetching: boolean;
  cityList: CityListTypes[] | [];
  cityListTotalCount: number;
  cityFetching: boolean;
  isState: null | boolean;
  isCity: null | boolean;
  success: number | null;
  fetching: boolean;
  error: string | null;
  message: string | null;
  statusCode: number | null;
  dispatchCheckUniqueEmailAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => void;
  dispatchCheckUniqueMobileNoAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => void;
  dispatchResetEmailError: () => void;
  dispatchResetEmailMessage: () => void;
  dispatchResetEmailFetching: () => void;
  dispatchResetIsEmail: () => void;
  dispatchResetMobileError: () => void;
  dispatchResetMobileMessage: () => void;
  dispatchResetMobileFetching: () => void;
  dispatchResetIsMobileNo: () => void;
  dispatchSignUpClientAction: (data: SignUpUserPayloadType) => void;
  dispatchGetCountryListAction: (
    data: GetCountryListSignUpDataPayloadType
  ) => void;
  dispatchGetAllStateAction: (data: GetStateListSignUpDataPayloadType) => void;
  dispatchGetAllCityAction: (data: GetCityListSignUpDataPayloadType) => void;
  dispatchResetStateListTotalCount: () => void;
  dispatchResetStateList: () => void;
  dispatchResetCityList: () => void;
  dispatchGetOtpSignUpAction: (data: GetSignUpOtpPayloadType) => void;
  dispatchSignUpOtpVerifyAction: (data: SignUpOtpVerifyPayloadType) => void;
  dispatchResetAuthError: () => void;
  dispatchResetAuthSuccess: () => void;
  dispatchResetAuthMessage: () => void;
};
const SignUpCard = ({
  token,
  emailMessage,
  emailFetching,
  isEmail,
  success,
  fetching,
  error,
  message,
  statusCode,
  dispatchCheckUniqueMobileNoAction,
  dispatchCheckUniqueEmailAction,
  mobileMessage,
  mobileFetching,
  isMobileNo,
  dispatchResetEmailError,
  dispatchResetEmailMessage,
  dispatchResetEmailFetching,
  dispatchResetIsEmail,
  dispatchResetMobileError,
  dispatchResetMobileMessage,
  dispatchResetMobileFetching,
  dispatchResetIsMobileNo,
  dispatchSignUpClientAction,
  countryList,
  countryListTotalCount,
  countryFetching,
  stateList,
  stateListTotalCount,
  stateFetching,
  cityList,
  cityListTotalCount,
  cityFetching,
  isState,
  isCity,
  dispatchGetCountryListAction,
  dispatchGetAllStateAction,
  dispatchGetAllCityAction,
  dispatchResetStateListTotalCount,
  dispatchResetStateList,
  dispatchResetCityList,
  dispatchGetOtpSignUpAction,
  dispatchSignUpOtpVerifyAction,
  dispatchResetAuthError,
  dispatchResetAuthSuccess,
  dispatchResetAuthMessage
}: AppProps) => {
   const {pathname} = window.location;
  const [addressState, setAddressState] = useState<DropDownType>({
    value: null,
    label: "Choose State...",
  });
  const [finalStateList, setFinalStateList] = useState<any>([]);
  // country
  const [countrySelectedList, setCountrySelectedList] = useState<any>([]);
  const [finalCountry, setCountry] = useState<DropDownType>({
    value: null,
    label: "Select..",
  });
  // city
  const [selectedCityList, setSelectedCityList] = useState<DropDownType>({
    value: null,
    label: "Select...",
  });
  const [finalCityList, setFinalCityList] = useState<any>([]);
  const [offset, setOffset] = useState<number>(0);
  const [stateOffset, setStateOffset] = useState<number>(0);
  const [cityOffset, setCityOffset] = useState<number>(0);

  const [text, setText] = useState<string>("");
  const [stateText, setStateText] = useState<string>("");
  const [cityText, setCityText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [isApiCall, setIsApiCall] = useState(false);
  const [isApiCityCall, setIsApiCityCall] = useState(false);
  const [countryDialCode, setCountryDialCode] = useState<DropDownType>({
    value: "+91",
    label: "🇮🇳 (+91)",
  });
  const [inputDetails, setInputDetails] = useState<any>({
    channel_partner: pathname==="/signup"?"finac":"au_bank",
    mobileNumber: "",
    otp: "",
    personalInfo: {},
    businessInfo: {},
    passworDetails: {
      email: "",
      password: "",
      newPassword: "",
    },
  });
  const [uniqueEmail, setUniqueEmail] = useState<UniqueEmailType>({
    operation: "add",
    email: null,
  });
  const [uniqueMobileNo, setUniqueMobileNo] = useState<UniqueMobileNoType>({
    operation: "add",
    mobile: null,
  });
  const [typeOfEntity, setTypeOfEntity] = useState({
    value: "",
    label: "Select..",
  });
  const [userProfileDetailsError, setUserProfileDetailsError] =
    useState<UserProfileDetailErrorType>({
      emailError: "",
      newPasswordError: "",
      newPasswordAgainError: "",
      countryError: "",
      stateError: "",
      cityError: "",
    });

  const [currentStep, setCurrentStep] = useState(0); // 0: Mobile Number, 1: OTP, 2: Personal, 3: Business 4: Set Password
  const [activeStep, setActiveStep] = useState(0); // Initialize with 0 :create account , 1 : personal 2 : busniess 3: password
  const [isOtpVerify, setIsOtpVerify] = useState(false);
  const [passwordPopUpShow, setPasswordPopUpshow] = useState(false);
  const [resendTimer, setResendTimer] = useState<number | null>(null);
  const [timerRemaining, setTimerRemaining] = useState(0);

  const [passwordValidation, setPasswordValidation] =
    useState<PasswordValidationType>({
      atLeast: false,
      upperCase: false,
      special: false,
      lowerCase: false,
      number: false,
    });
  useEffect(() => {
    setUserProfileDetailsError({
      emailError: "",
      newPasswordError: "",
      newPasswordAgainError: "",
      countryError: "",
      stateError: "",
      cityError: "",
    });
    dispatchResetStateList();
    dispatchResetCityList();
    dispatchResetAuthError();
    dispatchResetAuthMessage();
    localStorage.removeItem("personalInfo");
    localStorage.removeItem("businessDetail");
  }, []);




  useEffect(() => {
    let intervalId: any;
    if (timerRemaining > 0) {
      intervalId = setInterval(() => {
        setTimerRemaining((prev) => prev - 1);
      }, 1000);
    } else if (timerRemaining === 0 && resendTimer !== null) {
      setResendTimer(null);
    }
    return () => clearInterval(intervalId);
  }, [timerRemaining, resendTimer]);

  useEffect(() => {
    const persistedPersonalInfo = localStorage.getItem("personalInfo");
    const persistedBusinessInfo = localStorage.getItem("businessDetail");
    if (currentStep === 2) {
      if (persistedPersonalInfo) {
        const parsedPersistedPersonalInfo = JSON.parse(persistedPersonalInfo);
        setInputDetails((prev: any) => ({
          ...prev,
          personalInfo: parsedPersistedPersonalInfo,
        }));
      }
    } else if (currentStep === 3) {
      if (persistedBusinessInfo) {
        const parsedPersistedBusinessInfo = JSON.parse(persistedBusinessInfo);
        setInputDetails((prev: any) => ({
          ...prev,
          businessInfo: parsedPersistedBusinessInfo,
        }));
        setSelectedCityList({
          value: parsedPersistedBusinessInfo?.selectedCityList?.value,
          label: parsedPersistedBusinessInfo?.selectedCityList?.label,
        });
        setCountry({
          value: parsedPersistedBusinessInfo?.finalCountry?.value,
          label: parsedPersistedBusinessInfo?.finalCountry?.label,
        });
        setAddressState({
          value: parsedPersistedBusinessInfo?.addressState?.value,
          label: parsedPersistedBusinessInfo?.addressState?.label,
        });
        setTypeOfEntity({
          value: parsedPersistedBusinessInfo?.typeOfEntity?.value,
          label: parsedPersistedBusinessInfo?.typeOfEntity?.label,
        });
      }
    } else if (currentStep === 0) {
      localStorage.removeItem("personalInfo");
      localStorage.removeItem("businessDetail");
    }
  }, [currentStep]);

  // country state city
  useEffect(() => {
    const finalCountryData = countryList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (offset > 0) {
      setCountrySelectedList([...countrySelectedList, ...finalCountryData]);
    } else {
      setCountrySelectedList(finalCountryData);
    }
  }, [countryList]);

  useEffect(() => {
    dispatchResetCityList();
    dispatchResetStateList();
    let finalCountryData = {
      offset,
      limit,
      search_term: text,
    };
    if (offset <= countryListTotalCount) {
      dispatchGetCountryListAction(finalCountryData);
    }
    //eslint-disable-next-line
  }, [offset]);

  const fetchNewData = (search: string) => {
    const finalData = {
      offset,
      limit,
      search_term: text,
    };
    dispatchGetCountryListAction(finalData);
  };

  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        const finalData = {
          offset,
          limit,
          search_term: text,
        };
        dispatchGetCountryListAction(finalData);
      }
    },
    500,
    [text]
  );

  const handleChangeCountry = (data: any) => {
    setCountry({
      value: data?.value,
      label: data?.label,
    });

    if (data?.value && userProfileDetailsError.countryError) {
      setUserProfileDetailsError((prevState: UserProfileDetailErrorType) => ({
        ...prevState,
        countryError: "",
      }));
    }
    setUserProfileDetailsError((prevState: UserProfileDetailErrorType) => ({
      ...prevState,
      stateError: "",
    }));
  };

  useEffect(() => {
    dispatchResetCityList();
    if (finalCountry?.value) {
      let finalData: GetStateListSignUpDataPayloadType = {
        limit,
        offset: stateOffset,
        search_term: stateText,
        country_id: finalCountry.value,
      };

      if (stateOffset === 0) {
        dispatchGetAllStateAction(finalData);

        setIsApiCall(true);
      } else {
        dispatchGetAllStateAction(finalData);
        setStateOffset(0);
        setIsApiCall(true);
      }
    }
    //eslint-disable-next-line
  }, [finalCountry?.value]);

  useEffect(() => {
    dispatchResetCityList();
    if (isState === false && !stateFetching && finalCountry?.value) {
      let finalData: GetCityListSignUpDataPayloadType = {
        limit,
        offset: cityOffset,
        search_term: cityText,
        country_id: finalCountry?.value,
      };
      if (cityOffset === 0) {
        dispatchGetAllCityAction(finalData);
      } else {
        setCityOffset(0);
      }
    }
    //eslint-disable-next-line
  }, [isState]);

  useEffect(() => {
    const finalStateData = stateList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (stateOffset > 0) {
      setFinalStateList([...finalStateList, ...finalStateData]);
    } else {
      setFinalStateList(finalStateData);
    }
    //eslint-disable-next-line
  }, [stateList]);

  useEffect(() => {
    dispatchResetCityList();
    if (stateOffset != 0) {
      let finalStateData = {
        offset: stateOffset,
        limit,
        search_term: stateText,
        country_id: finalCountry?.value,
      };
      if (stateOffset <= stateListTotalCount) {
        dispatchGetAllStateAction(finalStateData);
      }
    }
    //eslint-disable-next-line
  }, [stateOffset]);

  const fetchData = (search: string) => {
    const finalData = {
      offset: stateOffset,
      limit,
      search_term: stateText,
      country_id: finalCountry?.value,
    };

    dispatchGetAllStateAction(finalData);
  };

  useDebounce(
    () => {
      if (stateText && isApiCall) {
        fetchData(stateText);
      } else if (isApiCall) {
        const finalData = {
          offset: stateOffset,
          limit,
          search_term: stateText,
          country_id: finalCountry?.value,
        };
        dispatchGetAllStateAction(finalData);
      }
    },
    500,
    [stateText]
  );

  const handleChangeState = (data: any) => {
    setAddressState({
      value: data?.value,
      label: data?.label,
    });
    if (data?.value && userProfileDetailsError?.stateError) {
      setUserProfileDetailsError((prevState: UserProfileDetailErrorType) => ({
        ...prevState,
        stateError: "",
      }));
    }
    setUserProfileDetailsError((prevState: UserProfileDetailErrorType) => ({
      ...prevState,
      cityError: "",
    }));
  };
  // city
  useEffect(() => {
    let finalData: GetCityListSignUpDataPayloadType = {
      limit,
      offset: cityOffset,
      search_term: cityText,
      state_id: addressState?.value,
    };
    if (addressState?.value) {
      if (cityOffset === 0) {
        dispatchGetAllCityAction(finalData);

        setIsApiCityCall(true);
      } else {
        dispatchGetAllCityAction(finalData);
        setCityOffset(0);
        setIsApiCityCall(true);
      }
    }
    //eslint-disable-next-line
  }, [addressState?.value]);

  useEffect(() => {
    const finalCityData = cityList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (cityOffset > 0) {
      setFinalCityList([...finalCityList, ...finalCityData]);
    } else {
      setFinalCityList(finalCityData);
    }
    //eslint-disable-next-line
  }, [cityList]);

  useEffect(() => {
    if (cityOffset !== 0) {
      let finalcityData = {
        offset: cityOffset,
        limit,
        search_term: cityText,
        state_id: addressState?.value,
      };
      if (cityOffset <= cityListTotalCount) {
        dispatchGetAllCityAction(finalcityData);
      }
    }
    //eslint-disable-next-line
  }, [cityOffset]);

  const fetchCityData = (search: string) => {
    const finalData = {
      offset: cityOffset,
      limit,
      search_term: cityText,
      state_id: addressState?.value,
    };
    dispatchGetAllCityAction(finalData);
  };

  useDebounce(
    () => {
      if (cityText && isApiCityCall) {
        fetchCityData(cityText);
      } else if (isApiCityCall) {
        const finalData = {
          offset: cityOffset,
          limit,
          search_term: cityText,
          state_id: addressState?.value,
        };
        dispatchGetAllCityAction(finalData);
      }
    },
    500,
    [cityText]
  );

  const handleChangeCity = (data: any) => {
    setSelectedCityList({
      value: data?.value,
      label: data?.label,
    });

    if (data?.value && userProfileDetailsError?.cityError) {
      setUserProfileDetailsError((prevState: UserProfileDetailErrorType) => ({
        ...prevState,
        cityError: "",
      }));
    }
  };

  useDebounce(
    () => {
      if (inputDetails?.mobileNumber) {
        dispatchCheckUniqueMobileNoAction(uniqueMobileNo);
      }
    },
    500,
    [uniqueMobileNo]
  );

  useDebounce(
    () => {
      const emailValidation = !isEmailValid(
        inputDetails?.passworDetails?.email
      );
      if (emailValidation && inputDetails?.passworDetails?.email?.length) {
        setUserProfileDetailsError((prv: UserProfileDetailErrorType) => ({
          ...prv,
          emailError: "Email not valid",
        }));
      } else {
        setUserProfileDetailsError((prv: UserProfileDetailErrorType) => ({
          ...prv,
          emailError: "",
        }));
      }

      if (inputDetails?.passworDetails?.email) {
        dispatchCheckUniqueEmailAction(uniqueEmail);
      }
    },
    500,
    [uniqueEmail]
  );

  useEffect(() => {
    if (success === 1 && message === "OTP Verified Successfully!") {
      if(pathname==="/signup"){
        setCurrentStep(3);
      }
      else{
        setCurrentStep(2);
      }
      setActiveStep(1);
       dispatchResetAuthSuccess();
      dispatchResetAuthMessage();
    }
    if (
      success === 1 &&
      message === "OTP sent successfully to your mobile number!"
    ) {
      if (currentStep === 0) {
        toast.success("OTP sent successfully to your mobile number!", {
          duration: 2000,
        });

        setCurrentStep(1);
      }
    }
    if (error && error?.includes("Invalid OTP! Please try again!")) {
      setInputDetails((prevDetails: any) => ({
        ...prevDetails,
        otp: "",
      }));
    }

    if (
      currentStep === 1 &&
      success === 1 &&
      message === "OTP sent successfully to your mobile number!"
    ) {
      dispatchResetAuthSuccess();
      dispatchResetAuthMessage();
    }
    if (
      currentStep === 2 &&
      success === 1 &&
      message === "OTP Verified Successfully!"
    ) {
      dispatchResetAuthSuccess();
      dispatchResetAuthMessage();
    }
  }, [success, message, currentStep]);
  const handleMobileNext = async (data: any) => {
    dispatchResetAuthSuccess();
    dispatchResetAuthMessage();
    // setCurrentStep(1);
    setIsOtpVerify(true);
    dispatchGetOtpSignUpAction(data);
  };

  const handleOtpVerified = async (data: any) => {
    dispatchSignUpOtpVerifyAction(data);
    dispatchResetAuthSuccess();
    dispatchResetAuthMessage();

    setIsOtpVerify(false);
  };
  const handlePersonalInfoNext = (data: any) => {
    dispatchResetAuthSuccess();
    dispatchResetAuthMessage();
    setInputDetails({ ...inputDetails, personalInfo: data });
    setCurrentStep(3);
    setIsOtpVerify(false);
    setActiveStep(2);
  };

  const handleBusinessInfoNext = (data: any) => {
    setInputDetails({ ...inputDetails, businessInfo: data });
    setCurrentStep(4);
    setIsOtpVerify(false);
    setActiveStep(2);

    setUserProfileDetailsError((prevState) => ({
      ...prevState,
      ...(!finalCountry?.value && { countryError: "Please choose a country!" }),
      ...(isState &&
        !addressState?.value && { stateError: "Please choose a state!" }),
      ...(isCity &&
        !selectedCityList?.value && { cityError: "Please choose a city!" }),
    }));
  };
  const handleBackToPersonalInfo = (data: any) => {
    setInputDetails({ ...inputDetails, businessInfo: data });

    setCurrentStep(2);
    setActiveStep(1);
  };

  const handleBackToCreateAccount = () => {
    setCurrentStep(0);
  };
  const handleBackToBusinessAddress = () => {
    setCurrentStep(3);
    setActiveStep(1);
  };
  const handleEmailChange = (e: any) => {
    const finalData = {
      operation: "add",
      email: e.target.value,
    };
    setInputDetails((prevDetails: any) => ({
      ...prevDetails,
      passworDetails: {
        ...prevDetails.passworDetails,
        email: e.target.value,
      },
    }));

    setUniqueEmail(finalData);
    dispatchResetEmailError();
    dispatchResetEmailMessage();
    dispatchResetEmailFetching();
    dispatchResetIsEmail();
  };
  const handleInputChange = (e: any) => {
    if (e?.target?.name === "phone" && e?.target?.value?.length) {
      const finalData = {
        operation: "add",
        mobile: e?.target?.value?.trim(),
        email: null,
      };
      setUniqueMobileNo(finalData);
      dispatchResetMobileError();
      dispatchResetMobileMessage();
      dispatchResetMobileFetching();
      dispatchResetIsMobileNo();
    }

    const Value = e?.target?.value;
    setInputDetails((prev: any) => ({
      ...prev,
      mobileNumber: Value,
    }));
  };

  const handleSubmitUserDetail = (e: any) => {
    e.preventDefault();

    setUserProfileDetailsError({
      emailError: "",
      newPasswordError: "",
      newPasswordAgainError: "",
      countryError: "",
      stateError: "",
      cityError: "",
    });

    if (!inputDetails?.passworDetails?.email.trim().length) {
      setUserProfileDetailsError((prev: UserProfileDetailErrorType) => ({
        ...prev,
        emailError: "Email is required",
      }));
    }

    if (
      !isEmailValid(inputDetails?.passworDetails?.email) &&
      inputDetails?.passworDetails?.email.trim().length
    ) {
      setUserProfileDetailsError((prev: UserProfileDetailErrorType) => ({
        ...prev,
        emailError: "Email not valid",
      }));
    }

    if (!inputDetails?.passworDetails?.password?.trim().length) {
      setUserProfileDetailsError((prev: UserProfileDetailErrorType) => ({
        ...prev,
        passwordError: "Password is required",
      }));
    }

    if (
      inputDetails?.passworDetails?.newPassword?.length > 0 &&
      Object.values(passwordValidation).includes(false)
    ) {
      setUserProfileDetailsError((prev: UserProfileDetailErrorType) => ({
        ...prev,
        newPasswordError: "Password must meet requirements",
      }));
    }

    if (
      inputDetails?.passworDetails?.newPassword?.length > 0 &&
      inputDetails?.passworDetails?.newPassword !==
      inputDetails?.passworDetails?.password
    ) {
      setUserProfileDetailsError((prev: UserProfileDetailErrorType) => ({
        ...prev,
        newPasswordAgainError: "Password is not same",
      }));
    }

    if (
      inputDetails?.passworDetails?.email?.trim().length &&
      isEmailValid(inputDetails?.passworDetails?.email) &&
      inputDetails?.passworDetails?.password.trim().length &&
      inputDetails?.passworDetails?.newPassword?.length &&
      inputDetails?.passworDetails?.newPassword ===
      inputDetails?.passworDetails?.password &&
      // ((isState &&
      //   addressState?.value &&
      //   finalCountry?.value &&
      //   selectedCityList?.value) ||
      //   (!isState && finalCountry?.value) ||
      //   (isState && addressState?.value && finalCountry?.value && !isCity)) &&
      !Object.values(passwordValidation).includes(false)
    ) {
      let finalData = {
        inputDetails,
      };
      dispatchSignUpClientAction(finalData);
    }
  };
  const handleErrorSuccessModal = () => {
    if (success === 0) {
      if (
        success === 0 &&
        message?.includes("Invalid OTP! Please try again!")
      ) {
        dispatchResetAuthSuccess();
        dispatchResetAuthError();
        toast.error("Invalid OTP! Please try again!", {
          duration: 2000,
        });
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
            }}
          />
        );
      }
    }

    return false;
  };

  const steps = [
    {
      icon: CreateAccountIcon,
      redIcon: CreateAccountIcon,

    },
    {
      icon: PersonalInformationIcon,
      redIcon: PersonalInformationRedIcon,

    },
    {
      icon: BusinessInformationIcon,
      redIcon: BusinessInformationRedIcon,

    },
    {
      icon: PasswordSettingIcon,
      redIcon: PasswordSettingRedIcon,

    },
  ];
   const withoutAuSteps = [
       {
        icon: CreateAccountIcon,
        redIcon: CreateAccountIcon,
      },
   
      {
         icon: BusinessInformationIcon,
        redIcon: BusinessInformationRedIcon,
      },
      {
        icon: PasswordSettingIcon,
        redIcon: PasswordSettingRedIcon,
        },
    
  
    ];
      const stepsToDisplay = pathname==="/signup" ? withoutAuSteps :steps ;
  return (
    <div className="">
      <div className="mainSignUpContainer">
        <div className="signUpLeft">
          <LeftSideSignUpInfo
            currentStep={currentStep}
            isOtpVerify={isOtpVerify}
            activeStep={activeStep}
          />
        </div>
        {currentStep === 0 && (
          <div className=" main-signup">
            <div className="signup-container">
              <div className="logo-section mb-3 mt-5">
                <img src={ProjExelLogo} style={{ height: "40px" }} alt="logo"/>
                <div className="step-parent">
                  {stepsToDisplay?.map((step, index) => (
                    < >

                      <div key={index} className="step-indicator">
                        <span
                          className={`step${activeStep === index ? "active" : ""
                            }`}
                        >
                          <img
                            src={
                              activeStep === index || activeStep > index
                                ? step?.redIcon
                                : step?.icon
                            }
                            alt={' Icon'}
                          // className="left-pannel-image"
                          />
                        </span>
                        <span className="line"></span>
                      </div>

                    </>

                  ))}
                </div>
                <h5 className="mt-3">Create New Account</h5>
                <span className="description">
                  Please enter mobile number to create account on Finac
                </span>
              </div>



              <CreateAccountWithOtp
                countryDialCode={countryDialCode}
                setCountryDialCode={setCountryDialCode}
                inputDetails={inputDetails}
                setInputDetails={setInputDetails}
                onNext={handleMobileNext}
                mobileFetching={mobileFetching}
                isMobileNo={isMobileNo}
                mobileMessage={mobileMessage}
                handleInputChange={handleInputChange}
              />

              <div className="flex-row">
                <p
                  className="resend-link text-center"
                  style={{ marginTop: "28px" }}
                >
                  Already have an account?{" "}
                  <a
                    style={{ color: "#dd4433", cursor: "pointer" }}
                    href="/login"
                    target="_blank"
                  >
                    Sign In
                  </a>
                </p>
              </div>

              <p className="mobileCopyright">
                &copy; Copyright 2025 | AKSSAI ProjExel | All right reserved
              </p>
            </div>
          </div>
        )}
        {currentStep === 1 && (
          <VerifySignUpOtp
            inputDetails={inputDetails}
            setInputDetails={setInputDetails}
            onVerify={handleOtpVerified}
            handleBackToCreateAccount={handleBackToCreateAccount}
            countryDialCode={countryDialCode}
            dispatchGetOtpSignUpAction={dispatchGetOtpSignUpAction}
            resendTimer={resendTimer}
            setResendTimer={setResendTimer}
            timerRemaining={timerRemaining}
            setTimeRemaining={setTimerRemaining}
            activeStep={activeStep}
          />
        )}

        {currentStep === 2 && (
          <PersonalInformationForm onNext={handlePersonalInfoNext}
            activeStep={activeStep}

          />
        )}
        {currentStep === 3 && (
          <BusinessDetailForm
            onNext={handleBusinessInfoNext}
            onPrevious={handleBackToPersonalInfo}
            userProfileDetailsError={userProfileDetailsError}
            setUserProfileDetailsError={setUserProfileDetailsError}
            countrySelectedList={countrySelectedList}
            finalCountry={finalCountry}
            handleChangeCountry={handleChangeCountry}
            handleChangeState={handleChangeState}
            handleChangeCity={handleChangeCity}
            setText={setText}
            setOffset={setOffset}
            addressState={addressState}
            finalStateList={finalStateList}
            setStateText={setStateText}
            setStateOffset={setStateOffset}
            finalCityList={finalCityList}
            selectedCityList={selectedCityList}
            setCityText={setCityText}
            setCityOffset={setCityOffset}
            limit={limit}
            countryFetching={countryFetching}
            stateFetching={stateFetching}
            cityFetching={cityFetching}
            isState={isState}
            isCity={isCity}
            setAddressState={setAddressState}
            setCountry={setCountry}
            setSelectedCityList={setSelectedCityList}
            typeOfEntity={typeOfEntity}
            setTypeOfEntity={setTypeOfEntity}
            activeStep={activeStep}

          />
        )}
        {currentStep === 4 && (
          <PasswordDetails
            onNext={handleSubmitUserDetail}
            onPrevious={handleBackToBusinessAddress}
            userProfileDetailsError={userProfileDetailsError}
            setUserProfileDetailsError={setUserProfileDetailsError}
            inputDetails={inputDetails}
            setInputDetails={setInputDetails}
            handleEmailChange={handleEmailChange}
            email={inputDetails?.passworDetails?.email}
            password={inputDetails?.passworDetails?.password}
            newPassword={inputDetails?.passworDetails?.newPassword}
            passwordPopUpShow={passwordPopUpShow}
            passwordValidation={passwordValidation}
            setPasswordPopUpshow={setPasswordPopUpshow}
            setPasswordValidation={setPasswordValidation}
            isEmail={isEmail}
            emailMessage={emailMessage}
            emailFetching={emailFetching}
            activeStep={activeStep}
          />
        )}


      </div>
      {handleErrorSuccessModal()}
      <Toaster />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  emailMessage: state.auth.signUpEmailMessage,
  emailFetching: state.auth.signUpEmailFetching,
  isEmail: state.auth.isSignupEmail,
  mobileMessage: state.auth.singUpMobileMessage,
  mobileFetching: state.auth.signUpMobileFetching,
  isMobileNo: state.auth.isSignUpMobileNo,
  countryList: state.auth.countryList,
  countryListTotalCount: state.auth.countryListTotalCount,
  countryFetching: state.auth.countryFetching,
  stateList: state.auth.stateList,
  stateListTotalCount: state.auth.stateListTotalCount,
  stateFetching: state.auth.stateFetching,
  cityList: state.auth.cityList,
  cityListTotalCount: state.auth.cityListTotalCount,
  cityFetching: state.auth.cityFetching,
  isState: state.auth.isState,
  isCity: state.auth.isCity,
  success: state.auth.success,
  message: state.auth.message,
  fetching: state.auth.fetching,
  error: state.auth.error,
  statusCode: state.auth.statusCode,
  token: state.auth.token
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchCheckUniqueEmailAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => dispatch(checkUniqueEmailSignUpAction(data)),
  dispatchCheckUniqueMobileNoAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => dispatch(checkUniqueMobileNoSignUpAction(data)),
  dispatchResetIsEmail: () => dispatch(resetIsSignupEmail()),
  dispatchResetEmailError: () => dispatch(resetSignUpEmailError()),
  dispatchResetEmailMessage: () => dispatch(resetSignUpEmailMessage()),
  dispatchResetEmailFetching: () => dispatch(resetSignUpEmailFetching()),
  dispatchResetMobileError: () => dispatch(resetSignUpMobileError()),
  dispatchResetMobileMessage: () => dispatch(resetSingUpMobileMessage()),
  dispatchResetMobileFetching: () => dispatch(resetSignUpMobileFetching()),
  dispatchResetIsMobileNo: () => dispatch(resetIsSignUpMobileNo()),
  dispatchSignUpClientAction: (data: SignUpUserPayloadType) =>
    dispatch(signUpClientAction(data)),
  dispatchGetCountryListAction: (data: GetCountryListSignUpDataPayloadType) =>
    dispatch(getAllCountrySignUpAction(data)),
  dispatchGetAllStateAction: (data: GetStateListSignUpDataPayloadType) =>
    dispatch(getAllStateSignUpAction(data)),
  dispatchGetAllCityAction: (data: GetCityListSignUpDataPayloadType) =>
    dispatch(getAllCitySignUpAction(data)),

  dispatchResetStateListTotalCount: () => dispatch(resetStateListTotalCount()),
  dispatchResetStateList: () => dispatch(resetStateList()),
  dispatchResetCityList: () => dispatch(resetCityList()),
  dispatchGetOtpSignUpAction: (data: GetSignUpOtpPayloadType) =>
    dispatch(getOtpSignUpAction(data)),
  dispatchSignUpOtpVerifyAction: (data: SignUpOtpVerifyPayloadType) =>
    dispatch(signUpOtpVerifyAction(data)),
  dispatchResetAuthError: () => dispatch(resetAuthError()),

  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetAuthMessage: () => dispatch(resetAuthMessage()),

});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpCard);
